import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToText',
  standalone: true,
})
export class SecondsToText implements PipeTransform {
  transform(seconds: number): string {
    
    seconds = Math.abs(seconds)

    if (seconds == 0)
      return "0";

    const years = Math.floor(seconds / (365 * 24 * 60 * 60));
    seconds %= (365 * 24 * 60 * 60);

    const months = Math.floor(seconds / (30 * 24 * 60 * 60));
    seconds %= (30 * 24 * 60 * 60);

    const weeks = Math.floor(seconds / (7 * 24 * 60 * 60));
    seconds %= 7 * 24 * 60 * 60;

    const days = Math.floor(seconds / (24 * 60 * 60));
    seconds %= 24 * 60 * 60;

    const hours = Math.floor(seconds / (60 * 60));
    seconds %= 60 * 60;

    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    let result = [];
    if (years > 0) {
      result.push(`${years}y`);
    }
    if (months > 0) {
      result.push(`${months}mo`);
    }
    if (weeks > 0) {
      result.push(`${weeks}w`);
    }
    if (days > 0) {
      result.push(`${days}d`);
    }
    if (hours > 0) {
      result.push(`${hours}h`);
    }
    if (minutes > 0) {
      result.push(`${minutes}min`);
    }
    if (seconds > 0) {
      result.push(`${seconds}s`);
    }

    return result.join(' ');
  }
}
